export default __webpack_public_path__ + "31ed2076a11317609add352d585215bf.svg";